// DiagiaTopbar — sits above the page content. Language selector + help + CTA.
//
// The language selector drives the app-wide i18n instance: DiagIA chrome
// (via t()) AND the diagnostic engine's questions (DiagnosticPage reads
// i18n.language) follow it together — one selector, everything consistent.

import React from 'react';
import { Link } from 'react-router-dom';
import { FaQuestionCircle, FaArrowRight, FaGlobe } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const LANGS = [
  { code: 'fr', label: 'Français' },
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
];

export default function DiagiaTopbar() {
  const { t, i18n } = useTranslation();
  const current = (i18n.language || 'fr').split('-')[0];

  return (
    <header className="dia-topbar">
      <div className="dia-topbar-spacer" />
      <div className="dia-topbar-actions">
        <span className="dia-topbar-link" style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
          <FaGlobe />
          <select
            value={current}
            onChange={(e) => i18n.changeLanguage(e.target.value)}
            aria-label={t('diagia.language', 'Language')}
            style={{
              border: '1px solid #e5e7eb', borderRadius: 8, padding: '4px 8px',
              background: '#fff', fontSize: '0.85rem', cursor: 'pointer',
            }}
          >
            {LANGS.map((l) => (
              <option key={l.code} value={l.code}>{l.label}</option>
            ))}
          </select>
        </span>
        <button type="button" className="dia-topbar-link" disabled>
          <FaQuestionCircle /> {t('diagia.help', 'Aide')}
        </button>
        <Link to="/diagia/new" className="dia-topbar-cta">
          {t('diagia.start_diagnostic', 'Commencer le diagnostic')}
          <FaArrowRight />
        </Link>
      </div>
    </header>
  );
}
